export default {"src":"/_next/static/media/moj.bc05c030.svg","height":921,"width":2890,"blurWidth":0,"blurHeight":0};